<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Informações da ordem</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="">
            <div
              *ngIf="boobleModalData?.remmitanceType == 'INBOUND'"
              class="box-order"
            >
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Número:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.id }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Moeda: &nbsp;
                    <span class="value">
                      <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                      ><span class="ml-2">{{
                        this.currency?.description
                      }}</span>
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Valor de destino:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.currency?.description }}
                      {{ this.boobleModalData?.amount | amountPipe }}</span
                    ></span
                  ><br /><br />

                  <span class="p-text-grey">
                    Modalidade:&nbsp;
                    <span class="value">{{
                      getModalityText(this.boobleModalData?.modality)
                    }}</span></span
                  ><br /><br />

                  <span class="p-text-grey align-chip-platform">
                    Origem da operação:&nbsp;
                    <div
                      *ngIf="boobleModalData?.orderSource === 'HOMEBROKER'"
                      class="chip-platform chip-pink"
                      title="Plataforma"
                    >
                      Plataforma
                    </div>

                    <div
                      *ngIf="boobleModalData?.orderSource === 'PARTNER'"
                      class="chip-platform chip-blue"
                      title="Parceiro"
                    >
                      Parceiro
                    </div>

                    <div
                      *ngIf="boobleModalData?.orderSource === 'ADMIN'"
                      class="chip-platform chip-order-by-admin"
                      title="Operação"
                    >
                      Operação
                    </div>

                    <div
                      *ngIf="boobleModalData?.orderSource === 'EXCHANGE'"
                      class="chip-platform chip-exchange"
                      title="Exchange"
                    >
                      Exchange
                    </div> </span
                  ><br /><br />
                </div>

                <div
                  *ngIf="this.boobleModalData?.finality?.description"
                  class="col-md-6"
                >
                  <span class="p-text-grey"
                    >Pagamento no exterior: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.conciliations[0]?.paymentDate
                        | date : "dd/MM/yyyy"
                    }}</span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Número do boleto:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.slipCode }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Status: &nbsp;
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'PENDING_INVOICE_ATTACHMENT'
                      "
                      class="value"
                    >
                      Invoice pendente
                    </span>
                    <span
                      *ngIf="this.boobleModalData?.statusFlow == 'PROCESSING'"
                      class="value"
                    >
                      Em análise
                    </span>
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'PENDING_PAYMENT_INFORMATION'
                      "
                      class="value"
                    >
                      Pendente informações de pagamento
                    </span>
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'AVAILABLE_QUOTATION'
                      "
                      class="value"
                    >
                      Aguardando cotação
                    </span>
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'REPROVED_WITH_CORRECTION'
                      "
                      class="value"
                    >
                      Reprovada
                    </span>
                    <span
                      *ngIf="
                        this?.boobleModalData?.reasonRefusalPayment ==
                        'Pagamento por conta errada'
                      "
                      class="value"
                    >
                      Pagamento por conta errada
                    </span>
                    <span
                      *ngIf="
                        this?.boobleModalData?.reasonRefusalPayment ==
                        'Pagamento incompleto'
                      "
                      class="value"
                    >
                      Pagamento incompleto
                    </span>
                    <span
                      *ngIf="
                        this?.boobleModalData?.reasonRefusalPayment == 'Outros'
                      "
                      class="value"
                    >
                      Outro
                    </span>
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                          'AVAILABLE_PAYMENT' &&
                        this.boobleModalData?.remmitanceType == 'OUTBOUND'
                      "
                      class="value"
                    >
                      Aguardando efetivação
                    </span>
                    <span
                      *ngIf="
                        (this.boobleModalData?.statusFlow ==
                          'AVAILABLE_PAYMENT' ||
                          this.boobleModalData?.statusFlow ==
                            'IDENTIFYING_PAYMENT') &&
                        !this.boobleModalData?.confirmationTreasury
                      "
                      class="value"
                      title="Aguardando tesouraria"
                      >Aguardando tesouraria</span
                    >
                    <span
                      *ngIf="
                        (this.boobleModalData?.statusFlow ==
                          'AVAILABLE_PAYMENT' ||
                          this.boobleModalData?.statusFlow ==
                            'IDENTIFYING_PAYMENT') &&
                        this.boobleModalData?.confirmationTreasury &&
                        !this.boobleModalData?.confirmationSlip
                      "
                      class="value"
                      title="Pronto para boletar"
                      >Pronto para boletar</span
                    >
                    <span
                      *ngIf="
                        (this.boobleModalData?.statusFlow ==
                          'AVAILABLE_PAYMENT' ||
                          this.boobleModalData?.statusFlow ==
                            'IDENTIFYING_PAYMENT') &&
                        this.boobleModalData?.confirmationTreasury &&
                        this.boobleModalData?.confirmationSlip &&
                        this.boobleModalData?.remmitanceType == 'INBOUND'
                      "
                      class="value"
                      title="A confirmar pagamento"
                      >A confirmar pagamento</span
                    >
                    <span
                      *ngIf="this.boobleModalData?.statusFlow == 'CANCELED'"
                      class="value"
                    >
                      Cancelada
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'PENDING_LIQUIDATION'
                      "
                      class="value"
                    >
                      Fechamento concluído
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT'
                        && this.boobleModalData?.remmitanceType == 'OUTBOUND'
                      "
                      class="value"
                    >
                      Aguardando efetivação
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'IDENTIFYING_PAYMENT'
                         && this.boobleModalData?.remmitanceType == 'INBOUND'
                      "
                      class="value"
                    >
                      Identificando pagamento
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow == 'IDENTIFIED_PAYMENT'
                      "
                      class="value"
                    >
                      Pagamento identificado
                    </span>

                    <span
                      *ngIf="this.boobleModalData?.statusFlow == 'PAID'"
                      class="value"
                    >
                      Liquidada
                    </span> </span
                  ><br /><br />

                  <span class="p-text-grey">
                    Finalidade:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.finality?.description }}
                    </span></span
                  ><br /><br />
                </div>
              </div>

              <ng-container
                *ngIf="
                  this?.boobleModalData?.reasonRefusalPayment ==
                  'Pagamento incompleto'
                "
              >
                <div class="row">
                  <div class="col">
                    <div class="col-warning">
                      <div class="d-flex justify-content-between margin-mb-16">
                        <div class="d-flex gap-10">
                          <img src="assets/image/information-icon-yellow.svg" />

                          <p class="text-p">
                            <strong class="weight-500"
                              >Pagamento incompleto!</strong
                            >
                          </p>
                        </div>
                      </div>

                      <p class="text-information">
                        O cliente enviou
                        {{ this.boobleModalData?.valueRefusalPayment | brl }},
                        faltando
                        {{
                          this.boobleModalData?.quotations[0]?.amountMN -
                            this.boobleModalData?.valueRefusalPayment | brl
                        }}
                        para o pagamento completo.
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this?.boobleModalData?.reasonRefusalPayment ==
                  'Pagamento por conta errada'
                "
              >
                <div class="row">
                  <div class="col">
                    <div class="col-warning">
                      <div class="d-flex justify-content-between margin-mb-16">
                        <div class="d-flex gap-10">
                          <img src="assets/image/information-icon-yellow.svg" />

                          <p class="text-p">
                            <strong class="weight-500"
                              >Pagamento por conta errada!</strong
                            >
                          </p>
                        </div>
                      </div>

                      <p class="text-information">
                        O pagamento foi realizado por uma conta de origem com
                        titularidade diferente do CNPJ cadastrado.
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this?.boobleModalData?.reasonRefusalPayment ==
                  'Cadastro de conta errada'
                "
              >
                <div class="row">
                  <div class="col">
                    <div class="col-warning">
                      <div class="d-flex justify-content-between margin-mb-16">
                        <div class="d-flex gap-10">
                          <img src="assets/image/information-icon-yellow.svg" />

                          <p class="text-p">
                            <strong class="weight-500"
                              >Conta indevida cadastrada!</strong
                            >
                          </p>
                        </div>
                      </div>

                      <p class="text-information">
                        A conta cadastrada não com a mesma titularidade do
                        cliente.
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="this.boobleModalData?.descriptionRefusalPayment"
              >
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Motivo da recusa do pagamento
                </h4>
                <div class="row">
                  <div class="reason">
                    <span>
                      {{ this.boobleModalData?.descriptionRefusalPayment }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.boobleModalData?.statusFlow == 'REPROVED_WITH_CORRECTION'
                "
              >
                <h4>Motivo da reprovação</h4>
                <div class="row mg-bottom-32">
                  <div class="reason">
                    <span>
                      {{ this.boobleModalData?.reprovedMsg }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.boobleModalData?.statusFlow == 'CANCELED' &&
                  this.boobleModalData?.reprovedMsg
                "
              >
                <h4>Motivo do cancelamento</h4>
                <div class="row">
                  <div class="reason">
                    <span>
                      {{ this.boobleModalData?.reprovedMsg }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="boobleModalData?.orderSource === 'PARTNER'">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do parceiro
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome do parceiro:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.corporateAccount
                            ?.businessPartner?.companyName ||
                            this.boobleModalData?.individualAccount
                              ?.businessPartner?.companyName
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Agência:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.corporateAccount
                            ?.businessPartner?.agencyNumber ||
                            this.boobleModalData?.individualAccount
                              ?.businessPartner?.agencyNumber
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>
              </ng-container>

              <h4 class="mg-bottom-32 mg-top-8 title-generic">
                Dados do cliente
              </h4>
              <div *ngIf="this.boobleModalData?.tipoPessoa == 'PJ'" class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.corporateAccount?.companyName }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >CNPJ: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.corporateAccount?.cnpj
                        | mask : "AA.AAA.AAA/AAAA-00"
                    }}</span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Banco: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.corporateAccount?.bankAccount?.name
                    }}</span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Conta: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.corporateAccount?.bankAccount
                        ?.number
                    }}</span></span
                  ><br /><br />
                </div>
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Telefone:&nbsp;
                    <span class="value"
                      >{{
                        this.boobleModalData?.corporateAccount?.users[0]
                          ?.phoneNumber | mask : "(00) 00000-0000"
                      }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Agência: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.corporateAccount?.bankAccount
                        ?.agency
                    }}</span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Faturamento anual:&nbsp;
                    <span class="value">
                      {{
                        this.boobleModalData?.corporateAccount?.annualBilling
                          | brl
                      }}
                    </span></span
                  ><br /><br />
                </div>
                <div class="col-md-12">
                  <span class="p-text-grey">
                    E-mail:&nbsp;
                    <span class="value"
                      >{{
                        boobleModalData?.corporateAccount?.users[0].emailList ||
                          boobleModalData?.corporateAccount?.users[0].email
                      }}
                    </span></span
                  ><br /><br />
                </div>
              </div>
              <div *ngIf="this.boobleModalData?.tipoPessoa == 'PF'" class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.individualAccount?.name }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >CPF: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.individualAccount?.cpf
                        | mask : "000.000.000-00"
                    }}</span></span
                  ><br /><br />
                </div>
                <div class="col-md-6">
                  <span class="p-text-grey">
                    E-mail:&nbsp;
                    <span class="value"
                      >{{
                        this.boobleModalData?.individualAccount?.contact?.email
                      }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Telefone:&nbsp;
                    <span class="value"
                      >{{
                        this.boobleModalData?.individualAccount?.contact?.phone
                          | mask : "(00) 00000-0000"
                      }}
                    </span></span
                  ><br /><br />
                </div>
              </div>

              <h4 class="mg-bottom-32 mg-top-8 title-generic">
                Dados do pagador
              </h4>
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.sender?.companyName }}
                    </span></span
                  ><br /><br />
                  <span
                    *ngIf="this.boobleModalData?.sender?.email"
                    class="p-text-grey"
                  >
                    E-mail:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.sender?.email }}
                    </span></span
                  ><br /><br />
                </div>
                <div class="col-md-6">
                  <span class="p-text-grey">
                    País:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.sender?.country?.description }}
                    </span></span
                  ><br /><br />
                </div>
              </div>
              <ng-container *ngIf="this.boobleModalData?.quotations[0]">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do fechamento de câmbio
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Câmbio com spread:&nbsp;
                      <span class="value"
                        >R${{ commercial?.toString().replace(".", ",") }}</span
                      ></span
                    ><br /><br />

                    <span class="p-text-grey"
                      >Tarifa: &nbsp;
                      <span class="value">
                        {{ this.boobleModalData?.quotations[0]?.tariff | brl }}
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Valor em reais: &nbsp;
                      <span class="value">
                        {{
                          this.boobleModalData?.quotations[0]?.amountMN | brl
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-6">
                    <ng-container *ngIf="boobleModalData?.quotations[0]?.id">
                      <span class="p-text-grey">
                        Câmbio comercial:&nbsp;
                        <span class="value"
                          >R${{
                            this.boobleModalData?.quotations[0]?.rate
                              ?.toString()
                              .replace(".", ",")
                          }}</span
                        ></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >IOF ({{ iof * 100 | number : "1.2-2" }}%): &nbsp;
                        <span class="value"
                          >{{
                            commercial * this.boobleModalData?.amount * iof
                              | brl
                          }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Imposto de renda ({{ ir * 100 | number : "1.2-2" }}%):
                        &nbsp;
                        <span class="value">{{
                          getIr(
                            this.boobleModalData?.quotations[0]?.rate,
                            this.boobleModalData?.quotations[0]?.spread,
                            ir,
                            this.boobleModalData?.quotations[0]?.ptax
                          ) | brl
                        }}</span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Valor efetivo total: &nbsp;
                        <span class="value"
                          >{{
                            1
                              | currency
                                : this.boobleModalData?.currency?.description
                          }}
                          =
                          {{
                            this.boobleModalData?.quotations[0]?.vet | brl
                          }}</span
                        ></span
                      ><br /><br />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.boobleModalData?.levelingRateTreasury">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados da tesouraria
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Origem da moeda:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.conciliations[0]?.bankName }}
                      </span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Taxa de nivelamento:&nbsp;
                      <span class="value"
                        >R${{ this.boobleModalData?.levelingRateTreasury }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.boobleModalData?.contractSettlementNumber ||
                  this.boobleModalData?.orderSettlement
                    ?.contractSettlementNumber
                "
              >
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados da Liquidação
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Número do contrato:&nbsp;
                      <span
                        *ngIf="this.boobleModalData?.contractSettlementNumber"
                        class="value"
                        >{{ this.boobleModalData?.contractSettlementNumber }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>
              </ng-container>
            </div>

            <div
              *ngIf="boobleModalData.remmitanceType === 'OUTBOUND'"
              class="box-order"
            >
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Número:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.id }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Moeda: &nbsp;
                    <span class="value">
                      <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                      ><span class="ml-2">{{
                        this.currency?.description
                      }}</span>
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Valor de destino:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.currency?.description }}
                      {{ this.boobleModalData?.amount | amountPipe }}</span
                    ></span
                  ><br /><br />

                  <span class="p-text-grey">
                    Modalidade:&nbsp;
                    <span class="value">{{
                      getModalityText(this.boobleModalData?.modality)
                    }}</span></span
                  ><br /><br />

                  <span class="p-text-grey align-chip-platform">
                    Origem da operação:&nbsp;
                    <div
                      *ngIf="boobleModalData?.orderSource === 'HOMEBROKER'"
                      class="chip-platform chip-pink"
                      title="Plataforma"
                    >
                      Plataforma
                    </div>

                    <div
                      *ngIf="boobleModalData?.orderSource === 'PARTNER'"
                      class="chip-platform chip-blue"
                      title="Parceiro"
                    >
                      Parceiro
                    </div>

                    <div
                      *ngIf="boobleModalData?.orderSource === 'ADMIN'"
                      class="chip-platform chip-order-by-admin"
                      title="Operação"
                    >
                      Operação
                    </div>

                    <div
                      *ngIf="boobleModalData?.orderSource === 'EXCHANGE'"
                      class="chip-platform chip-exchange"
                      title="Exchange"
                    >
                      Exchange
                    </div> </span
                  ><br /><br />
                </div>

                <div class="col-md-6">
                  <span class="p-text-grey"
                    >Data de criação: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.createdDate | date : "dd/MM/yyyy"
                    }}</span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Finalidade:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.finality?.description }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Número do boleto:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.slipCode }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Status: &nbsp;
                    <span
                      *ngIf="this.boobleModalData?.statusFlow == 'PROCESSING'"
                      class="value"
                    >
                      Em análise
                    </span>
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'AVAILABLE_QUOTATION'
                      "
                      class="value"
                    >
                      Aguardando cotação
                    </span>
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'REPROVED_WITH_CORRECTION'
                      "
                      class="value"
                    >
                      Reprovada
                    </span>
                    <span
                      *ngIf="
                        this?.boobleModalData?.reasonRefusalPayment ==
                        'Pagamento por conta errada'
                      "
                      class="value"
                    >
                      Pagamento por conta errada
                    </span>
                    <span
                      *ngIf="
                        this?.boobleModalData?.reasonRefusalPayment ==
                        'Pagamento incompleto'
                      "
                      class="value"
                    >
                      Pagamento incompleto
                    </span>
                    <span
                      *ngIf="
                        this?.boobleModalData?.reasonRefusalPayment == 'Outros'
                      "
                      class="value"
                    >
                      Outro
                    </span>
                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                          'AVAILABLE_PAYMENT' &&
                        this.boobleModalData?.remmitanceType == 'OUTBOUND'
                      "
                      class="value"
                    >
                      Aguardando efetivação
                    </span>
                    <span
                      *ngIf="this.boobleModalData?.statusFlow == 'CANCELED'"
                      class="value"
                    >
                      Cancelada
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'PENDING_LIQUIDATION'
                      "
                      class="value"
                    >
                      Fechamento concluído
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT'
                        && this.boobleModalData?.remmitanceType == 'OUTBOUND'
                      "
                      class="value"
                    >
                      Aguardando efetivação
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow ==
                        'IDENTIFYING_PAYMENT'
                        && this.boobleModalData?.remmitanceType == 'INBOUND'
                      "
                      class="value"
                    >
                      Identificando pagamento
                    </span>

                    <span
                      *ngIf="
                        this.boobleModalData?.statusFlow == 'IDENTIFIED_PAYMENT'
                      "
                      class="value"
                    >
                      Pagamento identificado
                    </span>

                    <span
                      *ngIf="this.boobleModalData?.statusFlow == 'PAID'"
                      class="value"
                    >
                      Liquidada
                    </span> </span
                  ><br /><br />
                </div>
              </div>

              <ng-container
                *ngIf="
                  this?.boobleModalData?.reasonRefusalPayment ==
                  'Pagamento incompleto'
                "
              >
                <div class="row">
                  <div class="col">
                    <div class="col-warning">
                      <div class="d-flex justify-content-between margin-mb-16">
                        <div class="d-flex gap-10">
                          <img src="assets/image/information-icon-yellow.svg" />

                          <p class="text-p">
                            <strong class="weight-500"
                              >Pagamento incompleto!</strong
                            >
                          </p>
                        </div>
                      </div>

                      <p class="text-information">
                        O cliente enviou
                        {{ this.boobleModalData?.valueRefusalPayment | brl }},
                        faltando
                        {{
                          this.boobleModalData?.quotations[0]?.amountMN -
                            this.boobleModalData?.valueRefusalPayment | brl
                        }}
                        para o pagamento completo.
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this?.boobleModalData?.reasonRefusalPayment ==
                  'Pagamento por conta errada'
                "
              >
                <div class="row">
                  <div class="col">
                    <div class="col-warning">
                      <div class="d-flex justify-content-between margin-mb-16">
                        <div class="d-flex gap-10">
                          <img src="assets/image/information-icon-yellow.svg" />

                          <p class="text-p">
                            <strong class="weight-500"
                              >Pagamento por conta errada!</strong
                            >
                          </p>
                        </div>
                      </div>

                      <p class="text-information">
                        O pagamento foi realizado por uma conta de origem com
                        titularidade diferente do CNPJ cadastrado.
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="this.boobleModalData?.descriptionRefusalPayment"
              >
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Motivo da recusa do pagamento
                </h4>
                <div class="row">
                  <div class="reason">
                    <span>
                      {{ this.boobleModalData?.descriptionRefusalPayment }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.boobleModalData?.statusFlow == 'REPROVED_WITH_CORRECTION'
                "
              >
                <h4>Motivo da reprovação</h4>
                <div class="row">
                  <div class="reason">
                    <span>
                      {{ this.boobleModalData?.reprovedMsg }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.boobleModalData?.statusFlow == 'CANCELED' &&
                  this.boobleModalData?.reprovedMsg
                "
              >
                <h4>Motivo do cancelamento</h4>
                <div class="row mg-bottom-32">
                  <div class="reason">
                    <span>
                      {{ this.boobleModalData?.reprovedMsg }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="boobleModalData?.orderSource === 'PARTNER'">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do parceiro
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome do parceiro:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.corporateAccount
                            ?.businessPartner?.companyName ||
                            this.boobleModalData?.individualAccount
                              ?.businessPartner?.companyName
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Agência:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.corporateAccount
                            ?.businessPartner?.agencyNumber ||
                            this.boobleModalData?.individualAccount
                              ?.businessPartner?.agencyNumber
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>
              </ng-container>

              <h4 class="mg-bottom-32 mg-top-8 title-generic">
                Dados do cliente
              </h4>
              <div *ngIf="this.boobleModalData?.tipoPessoa == 'PJ'" class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.corporateAccount?.companyName }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >CNPJ: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.corporateAccount?.cnpj
                        | mask : "AA.AAA.AAA/AAAA-00"
                    }}</span></span
                  ><br /><br />
                </div>
                <div class="col-md-6">
                  <span class="p-text-grey">
                    E-mail:&nbsp;
                    <span
                      *ngFor="
                        let user of boobleModalData?.corporateAccount?.users
                      "
                      class="value"
                      >{{ user?.email }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Telefone:&nbsp;
                    <span class="value"
                      >{{
                        this.boobleModalData?.corporateAccount?.users[0]
                          ?.phoneNumber | mask : "(00) 00000-0000"
                      }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    Faturamento anual:&nbsp;
                    <span class="value">
                      {{
                        this.boobleModalData?.corporateAccount?.annualBilling
                          | brl
                      }}
                    </span></span
                  ><br /><br />
                </div>
              </div>
              <div *ngIf="this.boobleModalData?.tipoPessoa == 'PF'" class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.individualAccount?.name }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >CPF: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.individualAccount?.cpf
                        | mask : "000.000.000-00"
                    }}</span></span
                  ><br /><br />
                </div>
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Telefone:&nbsp;
                    <span class="value"
                      >{{
                        this.boobleModalData?.individualAccount?.contact?.phone
                          | mask : "(00) 00000-0000"
                      }}
                    </span></span
                  ><br /><br />
                </div>
                <div class="col-md-12">
                  <span class="p-text-grey">
                    E-mail:&nbsp;
                    <span class="value"
                      >{{
                        boobleModalData?.corporateAccount?.users[0].emailList ||
                          boobleModalData?.corporateAccount?.users[0].email
                      }}
                    </span></span
                  ><br /><br />
                </div>
              </div>

              <h4 class="mg-bottom-32 mg-top-8 title-generic">
                Dados do recebedor
              </h4>
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.receiver?.name }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Banco: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.receiver?.receiverAccount?.bank ||
                        this.boobleModalData?.receiver?.bankName
                    }}</span></span
                  ><br /><br />
                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount?.number ||
                      this.boobleModalData?.receiver?.account
                    "
                  >
                    <span class="p-text-grey"
                      >Conta: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.number || this.boobleModalData?.receiver?.account
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount
                        ?.institutionNumber
                    "
                  >
                    <span class="p-text-grey"
                      >Institution Number: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.institutionNumber
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount?.transit
                    "
                  >
                    <span class="p-text-grey"
                      >Transit: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.transit
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount?.address
                    "
                  >
                    <span class="p-text-grey"
                      >Address: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.address
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                  <ng-container
                    *ngIf="this.boobleModalData?.receiver?.receiverAccount?.cbu"
                  >
                    <span class="p-text-grey"
                      >CBU: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.cbu
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount?.sortCode
                    "
                  >
                    <span class="p-text-grey"
                      >Sort Code: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.sortCode
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                </div>

                <div class="col-md-6">
                  <span class="p-text-grey">
                    País:&nbsp;
                    <span class="value"
                      >{{
                        this.boobleModalData?.receiver?.country?.description
                      }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Código SWIFT: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.receiver?.receiverAccount?.swift ||
                        this.boobleModalData?.receiver?.swift
                    }}</span></span
                  ><br /><br />
                  <ng-container
                    *ngIf="this.boobleModalData?.receiver?.receiverAccount?.aba"
                  >
                    <span class="p-text-grey"
                      >ABA: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.aba
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount?.iban
                    "
                  >
                    <span class="p-text-grey"
                      >IBAN: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.iban
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount?.cable
                    "
                  >
                    <span class="p-text-grey"
                      >Cable: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.cable
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="this.boobleModalData?.receiver?.receiverAccount?.blz"
                  >
                    <span class="p-text-grey"
                      >BLZ: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.blz
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="this.boobleModalData?.receiver?.receiverAccount?.fcc"
                  >
                    <span class="p-text-grey"
                      >FFC: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.fcc
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="
                      this.boobleModalData?.receiver?.receiverAccount?.cuit
                    "
                  >
                    <span class="p-text-grey"
                      >CUIT: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.cuit
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container
                    *ngIf="this.boobleModalData?.receiver?.receiverAccount?.bsb"
                  >
                    <span class="p-text-grey"
                      >BSB: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.bsb
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                </div>
              </div>

              <ng-container
                *ngIf="
                  this.boobleModalData?.receiver?.intermediaryAccount?.country
                    ?.description
                "
              >
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do banco intermediário
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      País:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.country?.description
                        }}
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Banco: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.bank
                      }}</span></span
                    ><br /><br />
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.number
                      "
                    >
                      <span class="p-text-grey"
                        >Conta: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.number
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.institutionNumber
                      "
                    >
                      <span class="p-text-grey"
                        >Institution Number: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.institutionNumber
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.transit
                      "
                    >
                      <span class="p-text-grey"
                        >Transit: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.transit
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.address
                      "
                    >
                      <span class="p-text-grey"
                        >Address: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.address
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount?.cbu
                      "
                    >
                      <span class="p-text-grey"
                        >CBU: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cbu
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.sortCode
                      "
                    >
                      <span class="p-text-grey"
                        >Sort Code: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.sortCode
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                  </div>
                  <div class="col-md-6">
                    <ng-container>
                      <span class="p-text-grey"
                        >Cidade: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.city
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                    <span class="p-text-grey">
                      Código SWIFT: &nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.swift
                        }}
                      </span></span
                    ><br /><br />

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount?.aba
                      "
                    >
                      <span class="p-text-grey"
                        >ABA: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.aba
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.iban
                      "
                    >
                      <span class="p-text-grey"
                        >IBAN: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.iban
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.cable
                      "
                    >
                      <span class="p-text-grey"
                        >Cable: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cable
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount?.blz
                      "
                    >
                      <span class="p-text-grey"
                        >BLZ: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.blz
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount?.fcc
                      "
                    >
                      <span class="p-text-grey"
                        >FFC: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.fcc
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount
                          ?.cuit
                      "
                    >
                      <span class="p-text-grey"
                        >CUIT: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cuit
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.intermediaryAccount?.bsb
                      "
                    >
                      <span class="p-text-grey"
                        >BSB: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.bsb
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="this.boobleModalData?.quotations[0]">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do fechamento de câmbio
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Opção de envio:&nbsp;
                      <span
                        *ngIf="
                          boobleModalData?.quotations[0]?.deliveryOption ===
                          'SWIFT'
                        "
                        class="value"
                        >Envio tradicional (SWIFT)
                      </span>
                      <span
                        *ngIf="
                          boobleModalData?.quotations[0]?.deliveryOption ===
                          'NIUM'
                        "
                        class="value"
                        >Envio por Remessadora (NIUM)
                      </span></span
                    ><br /><br />
                    <ng-container
                      *ngIf="this.boobleModalData?.settlementFlowTreasury"
                    >
                      <span class="p-text-grey"
                        >Fluxo de liquidação: &nbsp;
                        <span class="value">
                          {{ this.boobleModalData?.settlementFlowTreasury }}
                          &nbsp;
                          {{
                            this.boobleModalData?.settlementDate
                              | date : "dd/MM/yyyy"
                          }}
                        </span></span
                      ><br /><br />
                    </ng-container>
                    <span class="p-text-grey">
                      Câmbio com spread:&nbsp;
                      <span class="value"
                        >R${{ commercial?.toString().replace(".", ",") }}</span
                      ></span
                    ><br /><br />

                    <span class="p-text-grey"
                      >Tarifa: &nbsp;
                      <span class="value">
                        {{ this.boobleModalData?.quotations[0]?.tariff | brl }}
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Valor em reais: &nbsp;
                      <span class="value">
                        {{
                          this.boobleModalData?.quotations[0]?.amountMN | brl
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-6">
                    <ng-container *ngIf="boobleModalData?.quotations[0]?.id">
                      <span class="p-text-grey"
                        >IOF ({{ iof * 100 | number : "1.2-2" }}%): &nbsp;
                        <span class="value"
                          >{{
                            commercial * this.boobleModalData?.amount * iof
                              | brl
                          }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Imposto de renda ({{ ir * 100 | number : "1.2-2" }}%):
                        &nbsp;
                        <span class="value">{{
                          getIr(
                            this.boobleModalData?.quotations[0]?.rate,
                            this.boobleModalData?.quotations[0]?.spread,
                            ir,
                            this.boobleModalData?.quotations[0]?.ptax
                          ) | brl
                        }}</span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Câmbio comercial:&nbsp;
                        <span class="value"
                          >R${{
                            this.boobleModalData?.quotations[0]?.rate
                              ?.toString()
                              .replace(".", ",")
                          }}</span
                        ></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Valor efetivo total: &nbsp;
                        <span class="value"
                          >{{
                            1
                              | currency
                                : this.boobleModalData?.currency?.description
                          }}
                          =
                          {{
                            this.boobleModalData?.quotations[0]?.vet | brl
                          }}</span
                        ></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Spread:
                        <span class="value"
                          >{{
                            this.boobleModalData?.quotations[0]?.spread * 100
                              | number : "1.2-2"
                          }}%</span
                        ></span
                      ><br /><br />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.boobleModalData?.bankCurrencyTreasury">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados da tesouraria
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Origem da moeda:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.bankCurrencyTreasury }}
                      </span></span
                    ><br /><br />
                    <ng-container
                      *ngIf="this.boobleModalData?.settlementFlowTreasury"
                    >
                      <span class="p-text-grey"
                        >Fluxo de liquidação: &nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.settlementFlowTreasury }}
                          &nbsp;
                          {{
                            this.boobleModalData?.settlementDate
                              | date : "dd/MM/yyyy"
                          }}</span
                        ></span
                      ><br /><br />
                    </ng-container>
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Taxa de nivelamento:&nbsp;
                      <span class="value"
                        >R${{ this.boobleModalData?.levelingRateTreasury }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.boobleModalData?.contractSettlementNumber ||
                  this.boobleModalData?.orderSettlement
                    ?.contractSettlementNumber
                "
              >
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados da Liquidação
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Número do contrato:&nbsp;
                      <span
                        *ngIf="this.boobleModalData?.contractSettlementNumber"
                        class="value"
                        >{{ this.boobleModalData?.contractSettlementNumber }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="boobleModalData?.orderSource === 'EXCHANGE'">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados de log
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Liquidado em:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.settlementDate ??
                            this.boobleModalData?.conciliations[0]
                              ?.dateConciliation | date : "dd/MM/yyyy"
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Envio de comprovantes:&nbsp;
                      <span class="value"> </span></span
                    ><br /><br />
                  </div>
                </div>
              </ng-container>
            </div>
            <div
              *ngIf="
                boobleModalData?.orderSettlement?.exchangeContractFile ||
                boobleModalData?.orderSettlement?.proofOperationFile
              "
              class="box-order"
            >
              <div class="mb-2">
                <h4 class="black-text anex-text">Documentos anexados</h4>
              </div>

              <ng-container>
                <mat-tab-group
                  mat-stretch-tabs="false"
                  mat-align-tabs="start"
                  animationDuration="0ms"
                >
                  <mat-tab label="Documentos da liquidação">
                    <div>
                      <div class="container-documents">
                        <ng-container
                          *ngIf="
                            boobleModalData?.orderSettlement
                              ?.exchangeContractFile
                          "
                        >
                          <div
                            class="d-flex file-exclude justify-content-between align-items-md-center"
                          >
                            <div class="d-flex elipsis name-file-with-icon">
                              <img src="assets/image/clip-icon.svg" />

                              <span
                                class="black-text name-file"
                                matTooltip="Contrato de câmbio"
                                >Contrato de câmbio</span
                              >
                            </div>

                            <div class="d-flex btn-delete-file">
                              <span
                                class="blue-text"
                                (click)="
                                  downloadAttachmentByName(
                                    boobleModalData?.orderSettlement
                                      ?.exchangeContractFile
                                  )
                                "
                                >Baixar</span
                              >

                              <img src="assets/image/download-icon.svg" />
                            </div>
                          </div>
                        </ng-container>
                        <ng-container
                          *ngIf="
                            boobleModalData?.orderSettlement?.proofOperationFile
                          "
                        >
                          <div
                            class="d-flex file-exclude justify-content-between align-items-md-center"
                          >
                            <div class="d-flex elipsis name-file-with-icon">
                              <img src="assets/image/clip-icon.svg" />

                              <span
                                class="black-text name-file"
                                matTooltip="Comprovante da operação
                              (Swift)"
                                >Comprovante da operação (Swift)</span
                              >
                            </div>

                            <div class="d-flex btn-delete-file">
                              <span
                                class="blue-text"
                                (click)="
                                  downloadAttachmentByName(
                                    boobleModalData?.orderSettlement
                                      ?.proofOperationFile
                                  )
                                "
                                >Baixar</span
                              >

                              <img src="assets/image/download-icon.svg" />
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab
                    *ngIf="
                      boobleModalData?.orderSettlement
                        ?.orderSettlementAttachments?.length > 0
                    "
                    label="Documentos da operação"
                  >
                    <div>
                      <div class="container-documents">
                        <ng-container
                          *ngFor="
                            let file of boobleModalData?.orderSettlement
                              ?.orderSettlementAttachments;
                            let i = index
                          "
                        >
                          <div
                            class="d-flex file-exclude justify-content-between align-items-md-center"
                          >
                            <div class="d-flex elipsis name-file-with-icon">
                              <img src="assets/image/clip-icon.svg" />

                              <span
                                class="black-text name-file"
                                [matTooltip]="file.fileName"
                                >{{ file.fileName }}</span
                              >
                            </div>

                            <div class="d-flex btn-delete-file">
                              <span
                                class="blue-text"
                                (click)="downloadAttachment(file)"
                                >Baixar</span
                              >

                              <img src="assets/image/download-icon.svg" />
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          class="mb-3 btn btn-dark-primary-outline-back"
          (click)="closeModal()"
          type="button"
        >
          Fechar
        </button>
        <button
          *ngIf="
            !boobleModalData?.orderSettlement?.exchangeContractFile ||
            !boobleModalData?.orderSettlement?.proofOperationFile ||
            boobleModalData?.orderSettlement?.orderSettlementAttachments
              ?.length === 0
          "
          type="button"
          class="btn-footer btn btn-dark-primary-blue"
          type="button"
          (click)="
            openSettlementDocumentsComponentModal(this.boobleModalData?.id)
          "
        >
          Enviar documentos da liquidação
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </div>
  </div>
</div>
